// import backgroundImg from '../assets/marriagelayout.png';

const passcodeDialogStyles = (theme) => {
  return {
    popOverContainer: {
      alignSelf: 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      maxWidth: 240,
    },
    titleDialog: {
      width: 420,
    },
    btnStyleWatch: {
      margin: theme.spacing(0.5),
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
      borderWidth: theme.spacing(0.2),
      color: '#fff',
      borderColor: '#008000',
      backgroundColor: '#008000', //#229954
      '&:hover': {
        backgroundColor: '#008000', //#68B162
        borderColor: '#00acc1',
      },
    },
    inputStyles: {
      minWidth: 200,
      width: 370,
      paddingLeft: 0,
      paddingRight: 0,
      marginBottom: theme.spacing(1),
      '& .MuiFormHelperText-contained': {
        marginLeft: 0,
        fontSize: 10,
      },
      '& .MuiFormHelperText-root': {
        marginTop: 0,
        fontSize: 10,
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#000000',
      },
      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#0000003b',
      },
    },
    btnStyleJoin: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      paddingLeft: theme.spacing(0.8),
      paddingRight: theme.spacing(0.8),
      borderWidth: theme.spacing(0.2),
      color: '#fff',
      borderColor: '#008000',
      backgroundColor: '#008000',
      // minWidth: theme.spacing(14),
      '&:hover': {
        backgroundColor: '#008000',
        borderColor: '#00acc1',
      },
    },
    arrowIcon: {
      padding: 0,
      marginRight: 0,
      height: 15,
      width: 15,
    },
    termsContainer: {
      // width: '100%',
      width: 370,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      // alignSelf: 'flex-end',
      marginTop: 5,
      paddingTop: 3,
      textAlign: 'justify',
    },
    termsText: {
      fontSize: theme.spacing(1.2),
      // color: '#3949AB'
    },
    policyLink: {
      color: '#3949AB',
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      fontWeight: '700',
      '&:hover': {
        color: '#00acc1',
      },
    },
  };
};

export default passcodeDialogStyles;
